import React from 'react';
import styled from "styled-components";

interface StreakCardProps {
    days: number | undefined;
}
const StreakCard: React.FC<StreakCardProps> = ({days}) => {
    return (
        <Container>
            <Days>{days}</Days>
            <Text>Days<br/>Streak</Text>
        </Container>
    );
};

export default StreakCard;

const Container = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
`;

const Days = styled.h1`
    font-size: 80px;
    line-height: 96px;
    font-weight: 800;
    margin: 0;
    `;

const Text = styled.h2`
    margin: 0;
    text-transform: capitalize;
    font-size: 21px;
    letter-spacing: 0.1rem;
    font-weight: 500;
    white-space: nowrap;
    `
